<template>
  <div>
    <div v-if="variant != 'filter'" class="label_PFormInputHour">{{ label }}</div>
    <p-drop-down-container>
      <template v-slot:content>
        <div :class="inputClassComp">{{ valueLocal }}</div>
      </template>
      <div class="dropDownContainer_PFormInputText">
        <input type="number" v-model="valueHourComp" class="input_PFormInputText" @input="input" />
        <span>:</span>
        <input type="number" v-model="valueMinComp" class="input_PFormInputText" @input="input" />
      </div>
    </p-drop-down-container>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PDropDownContainer from "../PDropDownContainer/PDropDownContainer.vue";

@Component({
  components: { PDropDownContainer },
})
export class PFormInputHour extends Vue {
  @Prop({ required: true }) value!: string;
  @Watch("value", { immediate: true })
  onChangeValue(): void {
    if (
      this.value &&
      typeof this.value === "string" &&
      this.value != "" &&
      this.value.includes(":")
    ) {
      this.valueLocal = this.value;
      const arrayHour = this.valueLocal.split(":");
      this.valueHour = parseInt(arrayHour[0]);
      this.valueMin = parseInt(arrayHour[1]);
    }
  }
  @Prop({ required: false, default: "default" }) variant!: string; //default/filter
  @Prop({ required: false, default: "" }) label!: string;

  valueLocal = "00:00";
  valueHour = 0;
  valueMin = 0;
  get inputClassComp(): string {
    return "viewInput_PFormInputHour" + "_" + this.variant;
  }
  get valueHourComp(): number {
    return this.valueHour;
  }
  set valueHourComp(val: number) {
    const intVal = parseInt(val + "");

    if (intVal >= 0 && intVal < 24) {
      this.valueHour = intVal;
    } else if (intVal && intVal >= 0) {
      this.valueHour = intVal;
      this.valueHour = 23;
    } else if (intVal && intVal < 0) {
      this.valueHour = intVal;
      this.valueHour = 0;
    }
  }
  get valueMinComp(): number {
    return this.valueMin;
  }
  set valueMinComp(val: number) {
    const intVal = parseInt(val + "");
    if (intVal >= 0 && intVal < 60) {
      this.valueMin = intVal;
    } else if (intVal && intVal >= 0) {
      this.valueMin = intVal;
      this.valueMin = 59;
    } else if (intVal && intVal < 0) {
      this.valueMin = intVal;
      this.valueMin = 0;
    }
  }
  dameCondoscifras(num: number): string {
    if (num < 10) {
      return "0" + num;
    } else {
      return "" + num;
    }
  }

  input(): void {
    this.valueLocal =
      this.dameCondoscifras(this.valueHour) + ":" + this.dameCondoscifras(this.valueMin);

    this.$emit("input", this.valueLocal);
  }
}
export default PFormInputHour;
</script>
<style scoped>
.viewInput_PFormInputHour_filter {
  max-width: 60px;
  padding: 4px 11px 4px 11px;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #fff;
  cursor: pointer;
}
.viewInput_PFormInputHour_default {
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #fafafa;
  padding: 10px 10px 12px 10px;
  color: #807f7f;
  width: 100%;
  cursor: pointer;
}
.viewInput_PFormInputHour_line {
  border-top: 0 !important;
  border-bottom: solid 1px #e4e4e4 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-radius: 0 !important;
  width: 100%;
  padding: 10px 10px 12px 10px;
  color: #807f7f;
  cursor: pointer;
}
.dropDownContainer_PFormInputText {
  display: flex;
  padding: 10px 5px;
  align-items: center;
}
.input_PFormInputText {
  max-width: 45px;
  padding: 4px;
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #fff;
  margin: 5px;
}
.label_PFormInputHour {
  line-height: 1.23;
  color: #6f6f6f;
  min-height: 16px;
}
</style>
